<script setup>

import { computed, ref } from "vue";

const props = defineProps({
  break: {
    type: Object,
    required: true
  }

})

const lastBreak = computed(() => {
  if (props.break && props.break.breakSegments && props.break.breakSegments.length > 0) {
    return props.break.breakSegments[props.break.breakSegments.length - 1]
  }
  return null;
})

const breakData = computed(() => {
  if (!lastBreak.value) {
    return {
      start: '',
      reason: getReasonLabel('break')
    }
  }
  return {
    start: formatDate(lastBreak.value.start),
    reason: lastBreak.value.pauseReasonOtherText ? lastBreak.value.pauseReasonOtherText : getReasonLabel(lastBreak.value.pauseReason),
  };
})

const reasons = ref([
  { label: "Descanso", value: "break" },
  { label: "Cita con el médico", value: "medical_appointment" },
  { label: "Conciliación de hijos", value: "child_conciliation" },
  { label: "Conciliación familiar", value: "family_conciliation" },
  { label: "Otros", value: "other" }
]);

const getReasonLabel = (value) =>
  reasons.value.find(r => r.value === value)?.label || '';

const formatDate = (dateString) => {
  const date = new Date(String(dateString).replace(' ', 'T'));

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${hours}:${minutes}`;
};
</script>

<template>
  <div class="mt-1" style="display: block; text-align: center;">
    Desde {{ breakData.start }}
    <span v-if="breakData.reason">
      Razón: {{ breakData.reason }}
    </span>

  </div>
</template>